module.exports = __webpack_public_path__ + "img/HelloCircle2.183c4a09.svg";